import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useStyles from './Style'

export default function DataItem({ label, value, sm = 4 }) {
    const classes = useStyles();

    if (!value) 
        return null;
    
    return (
        <Grid item xs={12} sm={sm} className={classes.itemContainer}>
            <Typography className={classes.label}>{label}</Typography>
            <Typography className={classes.value}>{value}</Typography>
        </Grid>
    );
};